import React from "react";
import CommonNavbar from "../../components/CommonNavbar/CommonNavbar";
import PrivacyPolicy from "../../components/Policy/PrivacyPolicy";
import CommonFooter from "../../components/CommonFooter/CommonFooter";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <PrivacyPolicy />
      <CommonFooter />
    </div>
  );
};

export default PrivacyPolicyPage;
